import React, { Component } from 'react';
import './Follow.css';

/**
 * Instagram SVG Icon
 */
export default class IconSvgInstagram extends Component {

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        return (
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 50 50" >
				<g transform="translate(416, 800)">
					<path className="svg-icon-instagram" d="M-382.5-783.5c-1-1-2.2-1.2-3.6-1.3c-1.3-0.1-1.6-0.1-4.8-0.1s-3.6,0-4.8,0.1c-1.4,0.1-2.6,0.3-3.6,1.3
						c-1,1-1.2,2.2-1.3,3.6c-0.1,1.3-0.1,1.6-0.1,4.8s0,3.6,0.1,4.8c0.1,1.4,0.3,2.6,1.3,3.6c1,1,2.2,1.2,3.6,1.3
						c1.3,0.1,1.6,0.1,4.8,0.1s3.6,0,4.8-0.1c1.4-0.1,2.6-0.3,3.6-1.3c1-1,1.2-2.2,1.3-3.6c0.1-1.3,0.1-1.6,0.1-4.8s0-3.6-0.1-4.8
						C-381.3-781.2-381.6-782.5-382.5-783.5z M-391-768.8c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2
						S-387.6-768.8-391-768.8z M-384.6-780c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
						C-383.2-780.6-383.8-780-384.6-780z"/>
					<path className="svg-icon-instagram" d="M-391-799c-13.3,0-24,10.7-24,24s10.7,24,24,24s24-10.7,24-24S-377.7-799-391-799z M-379.1-770.1
						c-0.1,2-0.6,3.7-1.9,5c-1.4,1.4-3.1,1.9-5,1.9c-1.3,0.1-1.7,0.1-4.9,0.1s-3.7,0-4.9-0.1c-2-0.1-3.7-0.6-5-1.9
						c-1.4-1.4-1.9-3.1-1.9-5c-0.1-1.3-0.1-1.7-0.1-4.9s0-3.7,0.1-4.9c0.1-2,0.6-3.7,1.9-5c1.4-1.4,3.1-1.9,5-1.9
						c1.3-0.1,1.7-0.1,4.9-0.1s3.7,0,4.9,0.1c2,0.1,3.7,0.6,5,1.9c1.4,1.4,1.9,3.1,1.9,5c0.1,1.3,0.1,1.7,0.1,4.9
						S-379-771.3-379.1-770.1z"/>
					<circle className="svg-icon-instagram" cx="-391" cy="-775" r="4"/>
				</g>
			</svg>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/global/follow/IconSvgInstagram.jsx